import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MetaService } from '../../../services/meta.service';

@Component({
  selector: 'app-testing-and-review',
  templateUrl: './testing-and-review.component.html',
  styleUrls: ['./testing-and-review.component.scss']
})
export class TestingAndReviewComponent implements OnInit {
  imageUrl!: string;
  contentTitle = 'Testing and Quality Assurance - Xipe Tech';
  contentDescription = 'Ensure software excellence with XipeTech’s Testing and Quality Assurance services. We deliver bug-free, high-performance applications through rigorous testing and advanced QA methodologies.';
  contentKeywords = 'Testing and Quality Assurance, QA services, software testing, application testing, quality assurance solutions, automated testing, manual testing, performance testing, functional testing, software QA company, XipeTech QA services';
  pageUrl!: string;
  siteTitle = 'Revolutionary IT Solutions – XipeTech';
  ext = 'png';

  constructor(private metaService: MetaService, private router: Router) { }

  ngOnInit(): void {
    const baseUrl = window.location.origin;
    // Set the page title
    this.metaService.setMetaData({
      title: this.contentTitle,
      description: this.contentDescription,
      keywords: this.contentKeywords,
      siteTitle: this.siteTitle,
      pageUrl: `${baseUrl}${this.router.url}`,
      imageUrl: `${baseUrl}/assets/img/xipetech.png`,
      ext: this.ext
    });
  }
}
